import { stateName } from './constants';

const localState = state => state[stateName];

export const getSuggestions = state => localState(state).suggestions;
export const getSuggestionsListId = state => localState(state).suggestionsListId;